var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconStatsMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 26 26",
    style: {
      enableBackground: "new 0 0 26 26"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.5,25.7h2.2c0.3,0,0.5-0.2,0.5-0.5V0.8c0-0.3-0.2-0.5-0.5-0.5H6.5C6.2,0.3,6,0.5,6,0.8v24.3C6,25.5,6.2,25.7,6.5,25.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.1,25.7h2.2c0.3,0,0.5-0.2,0.5-0.5v-9.5c0-0.3-0.2-0.5-0.5-0.5H1.1c-0.3,0-0.5,0.2-0.5,0.5v9.5 C0.6,25.5,0.9,25.7,1.1,25.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9,25.7H14c0.3,0,0.5-0.2,0.5-0.5V11.4c0-0.3-0.2-0.5-0.5-0.5h-2.2c-0.3,0-0.5,0.2-0.5,0.5v13.7 C11.3,25.5,11.6,25.7,11.9,25.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7,25.7h2.2c0.3,0,0.5-0.2,0.5-0.5V8.4c0-0.3-0.2-0.5-0.5-0.5h-2.2c-0.3,0-0.5,0.2-0.5,0.5v16.7 C22.1,25.5,22.4,25.7,22.7,25.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7,5.1v20.1c0,0.3,0.2,0.5,0.5,0.5h2.2c0.3,0,0.5-0.2,0.5-0.5V5.1c0-0.3-0.2-0.5-0.5-0.5h-2.2 C16.9,4.5,16.7,4.8,16.7,5.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStatsMenu);
export default __webpack_public_path__ + "static/media/icon_stats_menu.b0692376c6631d75d0b20a6a261cd763.svg";
export { ForwardRef as ReactComponent };